import React from "react";
import MapSelectionField from "./MapSelectionField";
import LandlordMapSelection from "./LandlordMapSelection";
import ValidatedField from "../../Helpers/FieldValidator/ValidatedField";
import { change } from "redux-form";
import { Typography } from "@material-ui/core";

const LocationFields = (props) => {
    const { tenant } = props;
    return (
        <ValidatedField
            name="address"
            component={tenant ? MapSelectionField : LandlordMapSelection}
            style={props.styling}
            required
            fullWidth
            tenant={tenant}
            onLocationUpdate={(state) => {
                const { dispatch, form } = props;
                dispatch(change(form, "location", state.location));
                dispatch(change(form, "address", state.address));
                dispatch(change(form, "radius", state.radius));
            }}
        />
    )
}

export default LocationFields
